var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[(
      _vm.salesPerformanceData &&
      _vm.salesPerformanceData.labels &&
      _vm.salesPerformanceData.revenue &&
      _vm.salesPerformanceData.ordersCount
    )?_c('apexchart',{key:_vm.apexChartsBarArea,ref:"apexchart",attrs:{"type":"area","height":"340","options":_vm.chartOptions,"series":_vm.chartOptions.series}}):_c('div',{staticClass:"d-flex justify-content-center align-items-center text-info h-100",staticStyle:{"min-height":"340px"}},[_vm._v(" Pas de collecte de données ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }